import React, { useEffect, useState } from 'react'
import { v3_upload_plan_approval_document } from '../../../actions/v3/planApproval';
import { toast } from 'react-toastify';
import { FaPlus, FaTrash } from 'react-icons/fa';
import CreatableSelect from 'react-select/creatable';
import { v4_fetch_mailbox_recipients, v4_mailbox_configuration } from '../../../actions/v4/mailBox';
import SendReport from './sendReport';
import { filterRecipientOption, mapRecipientOptions } from '../../MailBox/recipientSelectUtils';
import { uploadSelectedFiles } from '../../../utils/multipleFileUpload';


const Comments = ({ data, onAddComment, onChangeFavouriteStatus, selectComment, onUpdateStatus }) => {

    const [state, setState] = useState({
        comment: { name: 'comment', value: '', error: '', isRequired: true },
        document: { name: 'document', value: [{ fileName: '', originalFileName: '' }], isRequired: false, error: '' },
    })

    const [mailBoxes, setMailBox] = useState([]);


    const [statusState, setStatusState] = useState({
        status: {
            name: 'status', value: '', error: '', options: ['Draft', 'Open', 'Accepted', 'Follow Up', 'Cancelled', 'Archived', 'To Be Confirmed At Revision'], isRequired: true
        },
        remarks: { name: 'remarks', value: '', error: '', isRequired: false },
        comment: { name: 'comment', value: '', error: '', isRequired: true },
        document: { name: 'document', value: [{ fileName: '', originalFileName: '', existing: false }], isRequired: false, error: '' },
        sentEmail: { name: 'sentEmail', value: false, isRequired: false, error: '' },

        fromEmailId: { name: 'fromEmailId', value: '', error: '', isRequired: false },
        email: { name: 'email', value: [], options: [], error: '', isRequired: false },
        subject: { name: 'subject', value: '', error: '', isRequired: false },
        body: { name: 'body', value: '', error: '', isRequired: false },
        cc: { name: 'cc', value: [], options: [], error: '', isRequired: false },
    })


    useEffect(() => {
        v4_fetch_mailbox_recipients().then((res) => {
            if (res.status) {
                const options = mapRecipientOptions(res.result);
                setStatusState((prev) => ({
                    ...prev,
                    ['email']: {
                        ...prev['email'], options
                    },
                    ['cc']: {
                        ...prev['cc'], options
                    },
                }));
            }
        })
    }, [])
    useEffect(() => {
        if (statusState.sentEmail.value && mailBoxes.length === 0) {
            v4_mailbox_configuration().then((res) => {
                if (res.status) {
                    setMailBox(res.result);

                }
            });
        }
    }, [statusState.sentEmail.value]);
    const handleStatusStateChange = (e) => {
        const { name, value } = e.target;
        setStatusState(prev => ({
            ...prev,
            [name]: { ...prev[name], value, error: '' }
        }));
    };
    const handleStatusFileChange = async (index, files) => {
        const uploadedFiles = await uploadSelectedFiles(files, v3_upload_plan_approval_document);
        if (!uploadedFiles.length) return;

        setStatusState(prev => {
            const updatedFiles = [...prev.document.value];
            updatedFiles.splice(index, 1, ...uploadedFiles.map((file) => ({ ...file, existing: false })));
            return {
                ...prev,
                document: { ...prev.document, value: updatedFiles, error: '' }
            };
        });
    };
    const handleStatusUpdateSubmit = (commentId) => {

        // 1. Validate required fields
        let isValid = true;
        const updatedState = { ...statusState };

        Object.keys(statusState).forEach((key) => {
            if (statusState[key].isRequired && !statusState[key].value) {
                updatedState[key].error = 'This field is required';
                isValid = false;
            }
        });

        setStatusState(updatedState);
        if (!isValid) {
            toast.error('Please fill all required fields.');
            return;
        }

        const toEmails = statusState.email.value.map((e) => e.value);
        const ccEmails = statusState.cc.value.map((e) => e.value);

        // 2. Build payload
        const payload = {
            remarks: statusState.remarks.value,
            status: statusState.status.value,
            planId: data.PLAN_ID,
            commentId,
            comment: statusState.comment.value,
            document: statusState.document.value,
            revisionId: data?.ID,
            sentEmail: statusState.sentEmail.value,
            to: toEmails,
            subject: statusState.subject.value,
            html: statusState.body.value,
            id: statusState.fromEmailId.value,
            cc: ccEmails
        };


        onUpdateStatus(payload)
    };

    const handleFileChange = async (index, files) => {
        const uploadedFiles = await uploadSelectedFiles(files, v3_upload_plan_approval_document);
        if (!uploadedFiles.length) return;

        setState(prev => {
            const updatedFiles = [...prev.document.value];
            updatedFiles.splice(index, 1, ...uploadedFiles);
            return {
                ...prev,
                document: { ...prev.document, value: updatedFiles, error: '' }
            };
        });
    };

    const addFileField = () => {
        setState(prev => ({
            ...prev,
            document: {
                ...prev.document,
                value: [...prev.document.value, { fileName: '', originalFileName: '' }],
                error: ''
            }
        }));
    };

    const removeFileField = (index) => {
        const updatedFiles = state.document.value.filter((_, i) => i !== index);
        setState(prev => ({
            ...prev,
            document: {
                ...prev.document,
                value: updatedFiles,
                error: updatedFiles.length === 0 ? 'At least one document is required' : ''
            }
        }));
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prev => ({
            ...prev,
            [name]: { ...prev[name], value, error: '' }
        }));
    };

    const handleSubmit = async () => {

        // 1. Validate required fields
        let isValid = true;
        const updatedState = { ...state };

        Object.keys(state).forEach((key) => {
            if (state[key].isRequired && !state[key].value) {
                updatedState[key].error = 'This field is required';
                isValid = false;
            }
        });

        setState(updatedState);
        if (!isValid) {
            toast.error('Please fill all required fields.');
            return;
        }

        // 2. Build payload
        const payload = {
            comment: state.comment.value,
            document: state.document.value,
            revisionId: data?.ID
        };

        const success = await onAddComment(payload);

        if (success) {
            // ✅ Reset state after success
            setState({
                comment: { name: 'comment', value: '', error: '', isRequired: true },
                document: { name: 'document', value: [{ fileName: '', originalFileName: '' }], isRequired: false, error: '' },
            });
        }
    };
    const handleMultiSelectChange = (selectedOptions, name) => {
        debugger
        setStatusState((prev) => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: selectedOptions,
                error: '',
            },
        }));
    };


    return (
        <div className="plan-item-section">

            <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title mb-0">Comments</h4>
                <div>
                    <button
                        type="button"
                        className="btn btn-sm btn-primary me-2"
                        style={{
                            backgroundImage:
                                "linear-gradient(90deg, rgb(104, 149, 180), rgb(38, 85, 120))"
                        }}
                        data-bs-toggle="modal"
                        data-bs-target={`#sendMail`}
                    >
                        <i className="fas fa-paper-plane label-icon" /> Send Report

                    </button>

                    <button
                        type="button"
                        className="btn btn-sm btn-primary me-2"
                        data-bs-toggle="modal"
                        data-bs-target={`#commentModal`}
                        style={{
                            backgroundImage:
                                "linear-gradient(90deg, rgb(104, 149, 180), rgb(38, 85, 120))"
                        }}
                    >
                        <i className="fa fa-plus-circle label-icon" /> Create Comment
                    </button>

                </div>
            </div>
            <div
                className="modal fade"
                id={`sendMail`}
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex={-1}
                role="dialog"
                aria-labelledby="sendMailLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="sendMailLabel">
                                Send Report Mail
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <SendReport
                                data={data}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="modal fade"
                id={`commentModal`}
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex={-1}
                role="dialog"
                aria-labelledby="commentModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="commentModalLabel">
                                Add Comment
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <label>Comment <span >*</span></label>
                                    <textarea
                                        row='2'
                                        name={'comment'}
                                        placeholder='Enter Comment'
                                        value={state['comment'].value}
                                        onChange={handleChange}
                                        className={`form-control ${state['comment'].error ? 'is-invalid' : ''}`}
                                    />
                                    {state['comment'].error && <div className="invalid-feedback">{state['comment'].error}</div>}
                                </div>
                                <div className="col-md-12 mb-3">
                                    <label>Supporting File </label>
                                    {state.document.value.map((item, index) => (
                                        <div key={index} className="d-flex align-items-center mb-2">
                                            {item.fileName ? (
                                                <>
                                                    <div className="me-2 flex-grow-1">
                                                        <span>{item.originalFileName}</span>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={() => removeFileField(index)}
                                                    >
                                                        <FaTrash />
                                                    </button>
                                                </>
                                            ) : (
                                                <>
                                                    <input
                                                        type="file"
                                                        multiple
                                                        onChange={(e) => handleFileChange(index, e.target.files)}
                                                        className="form-control me-2"
                                                    />
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={() => removeFileField(index)}
                                                    >
                                                        <FaTrash />
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    ))}
                                    <div>
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary"
                                            onClick={addFileField}
                                        >
                                            <FaPlus className="me-1" /> Add Document
                                        </button>
                                    </div>
                                    {state['document'].error && <div className="invalid-feedback">{state['document'].error}</div>}
                                </div>
                            </div>
                            <div className="mt-3">
                                <button type="submit" className="btn btn-success me-2"
                                    onClick={() => {
                                        handleSubmit()

                                    }}
                                >Submit</button>
                                <button className="btn btn-danger text-white" onClick={() => {
                                    const modal = window.bootstrap.Modal.getInstance(document.getElementById(`commentModal`));
                                    if (modal) modal.hide();
                                }}>Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {data?.comments.map((item) => {
                const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
                const initials = item.CREATED_BY_NAME
                    .split(' ')
                    .map(word => word.charAt(0).toUpperCase())
                    .join('');
                return (
                    <>
                        <div className="plan-item-details mt-2">

                            <div className="user-name"
                                onClick={() => {
                                    selectComment(item.ID)
                                }}>{initials}

                            </div>
                            <div className="plan-modal">
                                <p onClick={() => {
                                    selectComment(item.ID)
                                }}>
                                    {item.COMMENT}
                                </p>
                                <div className="paln-signatur">

                                    <div className="plan-about-user">


                                        <p onClick={() => {
                                            selectComment(item.ID)
                                        }}>
                                            Create By <span>{item.CREATED_BY_NAME}</span>
                                        </p >
                                        <p onClick={() => {
                                            selectComment(item.ID)
                                        }}>
                                            Opened Against rev <span>{item.REVISION_NAME}</span>
                                        </p>
                                        <p className="cat-para">{item.STATUS}</p>


                                    </div>

                                    <div className="plan-about-user-copy">
                                        <p>
                                            <a href="#"
                                                data-bs-toggle="modal"
                                                data-bs-target={`#statusUpdateModal-${item.ID}`}
                                                onClick={() => {
                                                    setStatusState(prev => ({
                                                        ...prev,
                                                        status: {
                                                            ...prev.status,
                                                            value: item.STATUS
                                                        },
                                                        comment: {
                                                            ...prev.status,
                                                            value: item.COMMENT
                                                        },
                                                        document: {
                                                            ...prev.status,
                                                            value: item.commentDocuments.length > 0 ? item.commentDocuments.map((doc) => {
                                                                return {
                                                                    fileName: doc.FILE_NAME, originalFileName: doc.ORIGINAL_FILE_NAME, existing: true
                                                                }
                                                            }) : [{ fileName: '', originalFileName: '', existing: false }]
                                                        }
                                                    }));
                                                }}

                                            >
                                                <i
                                                    className="bx bx-edit"
                                                    aria-hidden="true"
                                                />
                                            </a>
                                            <div
                                                className="modal fade"
                                                id={`statusUpdateModal-${item.ID}`}
                                                data-bs-backdrop="static"
                                                data-bs-keyboard="false"
                                                tabIndex={-1}
                                                role="dialog"
                                                aria-labelledby="statusUpdateModalLabel"
                                                aria-hidden="true"
                                            >
                                                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                                                    <div className="modal-content">
                                                        <div className="modal-header">
                                                            <h5 className="modal-title" id="statusUpdateModalLabel">
                                                                Update Status
                                                            </h5>
                                                            <button
                                                                type="button"
                                                                className="btn-close"
                                                                data-bs-dismiss="modal"
                                                                aria-label="Close"
                                                            />
                                                        </div>
                                                        <div className="modal-body">
                                                            <div className="row">
                                                                <div className="col-md-12 mb-3">
                                                                    <label>Status {statusState.status.isRequired && <span className='text-danger'> *</span>}</label>
                                                                    <select
                                                                        name={'status'}
                                                                        value={statusState['status'].value}
                                                                        onChange={handleStatusStateChange}
                                                                        className={`form-control ${statusState['status'].error ? 'is-invalid' : ''}`}
                                                                    >
                                                                        <option value=''>Select Status</option>
                                                                        {statusState.status.options.map((status) => {
                                                                            return (
                                                                                <option value={status}>{status}</option>

                                                                            )
                                                                        })}
                                                                    </select>
                                                                    {statusState['status'].error && <div className="invalid-feedback">{statusState['status'].error}</div>}
                                                                </div>
                                                                {statusState.status.value === 'Draft' &&
                                                                    <>
                                                                        <div className="col-md-12 mb-3">
                                                                            <label>Comment <span >*</span></label>
                                                                            <textarea
                                                                                row='2'
                                                                                name={'comment'}
                                                                                placeholder='Enter Comment'
                                                                                value={statusState['comment'].value}
                                                                                onChange={(e) => {
                                                                                    const { name, value } = e.target;
                                                                                    setStatusState(prev => ({
                                                                                        ...prev,
                                                                                        [name]: { ...prev[name], value, error: '' }
                                                                                    }));
                                                                                }}
                                                                                className={`form-control ${statusState['comment'].error ? 'is-invalid' : ''}`}
                                                                            />
                                                                            {statusState['comment'].error && <div className="invalid-feedback">{statusState['comment'].error}</div>}
                                                                        </div>
                                                                        <div className="col-md-12 mb-3">
                                                                            <label>Supporting File <span >*</span></label>
                                                                            {statusState.document.value.map((item, index) => (
                                                                                <div key={index} className="d-flex align-items-center mb-2">
                                                                                    {item.fileName ? (
                                                                                        <>
                                                                                            <div className="me-2 flex-grow-1">
                                                                                                <span>{item.originalFileName}</span>
                                                                                            </div>
                                                                                            <button
                                                                                                type="button"
                                                                                                className="btn btn-outline-danger"
                                                                                                onClick={() => {

                                                                                                    const updatedFiles = statusState.document.value.filter((_, i) => i !== index);
                                                                                                    setStatusState(prev => ({
                                                                                                        ...prev,
                                                                                                        document: {
                                                                                                            ...prev.document,
                                                                                                            value: updatedFiles,
                                                                                                            error: updatedFiles.length === 0 ? 'At least one document is required' : ''
                                                                                                        }
                                                                                                    }));
                                                                                                }}
                                                                                            >
                                                                                                <FaTrash />
                                                                                            </button>
                                                                                        </>
                                                                                    ) : (
                                                                                        <>
                                                                                            <input
                                                                                                type="file"
                                                                                                multiple
                                                                                                onChange={(e) => handleStatusFileChange(index, e.target.files)}
                                                                                                className="form-control me-2"
                                                                                            />
                                                                                            <button
                                                                                                type="button"
                                                                                                className="btn btn-outline-danger"
                                                                                                onClick={() => {

                                                                                                    const updatedFiles = statusState.document.value.filter((_, i) => i !== index);
                                                                                                    setStatusState(prev => ({
                                                                                                        ...prev,
                                                                                                        document: {
                                                                                                            ...prev.document,
                                                                                                            value: updatedFiles,
                                                                                                            error: updatedFiles.length === 0 ? 'At least one document is required' : ''
                                                                                                        }
                                                                                                    }));
                                                                                                }}
                                                                                            >
                                                                                                <FaTrash />
                                                                                            </button>
                                                                                        </>
                                                                                    )}
                                                                                </div>
                                                                            ))}
                                                                            <div>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-outline-primary"
                                                                                    onClick={() => {
                                                                                        setStatusState(prev => ({
                                                                                            ...prev,
                                                                                            document: {
                                                                                                ...prev.document,
                                                                                                value: [...prev.document.value, { fileName: '', originalFileName: '', existing: false }],
                                                                                                error: ''
                                                                                            }
                                                                                        }));
                                                                                    }}
                                                                                >
                                                                                    <FaPlus className="me-1" /> Add Document
                                                                                </button>
                                                                            </div>
                                                                            {statusState['document'].error && <div className="invalid-feedback">{statusState['document'].error}</div>}
                                                                        </div>
                                                                    </>

                                                                }

                                                                <div className="col-md-12 mb-3">
                                                                    <label>Send Email ? </label>
                                                                    &nbsp;
                                                                    &nbsp;
                                                                    <input
                                                                        type="checkbox"
                                                                        name={'sentEmail'}
                                                                        checked={statusState.sentEmail.value === true}
                                                                        onChange={(e) => {
                                                                            const checked = e.target.checked;

                                                                            setStatusState(prev => ({
                                                                                ...prev,
                                                                                sentEmail: {
                                                                                    ...prev.sentEmail,
                                                                                    value: checked,
                                                                                },
                                                                                fromEmailId: {
                                                                                    ...prev.fromEmailId,
                                                                                    isRequired: checked,
                                                                                },
                                                                                email: {
                                                                                    ...prev.email,
                                                                                    isRequired: checked,
                                                                                },
                                                                                subject: {
                                                                                    ...prev.subject,
                                                                                    isRequired: checked,
                                                                                },
                                                                                body: {
                                                                                    ...prev.body,
                                                                                    isRequired: checked,
                                                                                },
                                                                            }));
                                                                        }}
                                                                        className={`mt-1 form-check-input ${statusState['sentEmail'].error ? 'is-invalid' : ''}`}
                                                                    />
                                                                </div>
                                                                {statusState.sentEmail.value &&
                                                                    <div>
                                                                        <div className="mb-3">
                                                                            <select
                                                                                isMulti
                                                                                name="fromEmailId"
                                                                                value={statusState.fromEmailId.value}
                                                                                onChange={handleStatusStateChange}
                                                                                className="form-select"
                                                                            >
                                                                                <option value={''}> Send From </option>
                                                                                {mailBoxes?.map((mail) => {
                                                                                    return (
                                                                                        <option value={mail.ID}>{mail.EMAIL} </option>
                                                                                    )
                                                                                })}
                                                                            </select>
                                                                            {statusState.fromEmailId.error && <small className="text-danger">{statusState.fromEmailId.error}</small>}
                                                                        </div>
                                                                        <div className="mb-3">
                                                                            <CreatableSelect
                                                                                isMulti
                                                                                name="email"
                                                                                value={statusState.email.value}
                                                                                options={statusState.email.options} // Optional: preload some emails if needed
                                                                                filterOption={filterRecipientOption}
                                                                                onChange={(e) => handleMultiSelectChange(e, 'email')}
                                                                                className="basic-multi-select"
                                                                                classNamePrefix="select"
                                                                                placeholder="To"
                                                                                isClearable
                                                                            />
                                                                            {statusState.email.error && <small className="text-danger">{statusState.email.error}</small>}
                                                                        </div>
                                                                        {statusState.email.value.length > 0 && <div className="mb-3">
                                                                            <CreatableSelect
                                                                                isMulti
                                                                                name="cc"
                                                                                value={statusState.cc.value}
                                                                                options={statusState.cc.options} // Optional: preload some emails if needed
                                                                                filterOption={filterRecipientOption}
                                                                                onChange={(e) => handleMultiSelectChange(e, 'cc')}
                                                                                className="basic-multi-select"
                                                                                classNamePrefix="select"
                                                                                placeholder="CC"
                                                                                isClearable
                                                                            />
                                                                            {statusState.cc.error && <small className="text-danger">{statusState.cc.error}</small>}
                                                                        </div>}
                                                                        <div className="mb-3">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="subject"
                                                                                value={statusState.subject.value}
                                                                                onChange={handleStatusStateChange}
                                                                                placeholder="Subject"
                                                                            />
                                                                            {statusState.subject.error && <small className="text-danger">{statusState.subject.error}</small>}
                                                                        </div>
                                                                        <div className="mb-3">
                                                                            <textarea
                                                                                className="form-control"
                                                                                rows="5"
                                                                                name="body"
                                                                                value={statusState.body.value}
                                                                                onChange={handleStatusStateChange}
                                                                                placeholder="Write your message..."
                                                                            />
                                                                            {statusState.body.error && <small className="text-danger">{statusState.body.error}</small>}
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className="mt-3">
                                                                <button className="btn btn-success me-2"
                                                                    onClick={() => {
                                                                        handleStatusUpdateSubmit(item.ID)

                                                                    }}
                                                                >Send</button>

                                                                <button className="btn btn-danger text-white" onClick={() => {
                                                                    const modal = window.bootstrap.Modal.getInstance(document.getElementById(`statusUpdateModal-${item.ID}`));
                                                                    if (modal) modal.hide();
                                                                }}>Cancel</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <br />
                                            <a href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    navigator.clipboard.writeText(item.COMMENT);
                                                    toast.success('Copied to clipboard!');
                                                }}>
                                                {" "}
                                                <i
                                                    className="mdi mdi-content-copy"
                                                    aria-hidden="true"
                                                />
                                            </a>

                                            <br />
                                            <i
                                                className={`bx ${Number(item.IS_FAVOURITE) ? 'bxs-star' : 'bx-star'}`}
                                                style={{ color: Number(item.IS_FAVOURITE) ? '#f1c40f' : '#999', cursor: 'pointer' }}
                                                onClick={() => {
                                                    onChangeFavouriteStatus({
                                                        commentId: item.ID,
                                                        comment: item.COMMENT,
                                                        favouriteStatus: Number(!Number(item.IS_FAVOURITE)),
                                                    });
                                                }}
                                            />
                                        </p>
                                    </div>
                                </div>


                                <div className="uplodeimageseep">
                                    {item.commentDocuments.map((doc, i) => {

                                        const fileExt = doc.ORIGINAL_FILE_NAME?.split('.').pop()?.toLowerCase()
                                        const isImage = imageExtensions.includes(fileExt)
                                        const previewUrl = `${process.env.REACT_APP_BASE_URL}/v3/planApproval/document/preview/${doc.PLAN_ID}/${doc.REV_ID}/${doc.FILE_NAME}`;
                                        const downloadUrl = `${process.env.REACT_APP_BASE_URL}/v3/planApproval/document/download/${doc.PLAN_ID}/${doc.REV_ID}/${doc.FILE_NAME}`;

                                        return (
                                            <div className="uplodeitem" key={i}>
                                                {isImage && (
                                                    <div className="ship-img-box">
                                                        <img
                                                            src={previewUrl}
                                                            alt={doc.ORIGINAL_FILE_NAME}
                                                        />
                                                    </div>
                                                )}
                                                <div className="img-caption">
                                                    <p>
                                                        <a
                                                            href={previewUrl}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            {doc.ORIGINAL_FILE_NAME}
                                                        </a>
                                                    </p>
                                                    <div className="d-flex justify-content-center gap-2">
                                                        <a href={previewUrl} target="_blank" rel="noopener noreferrer" className="small text-info">Preview</a>
                                                        <a href={downloadUrl} target="_blank" rel="noopener noreferrer" className="small">Download</a>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div >


                        </div >
                    </>
                )
            })}


        </div >

    )
}

export default Comments
